export const LOADER_MANT_INDKS            =     'LOADER_MANT_INDKS';
export const LOADER_MANT_INDK             =     'LOADER_MANT_INDK';
export const SAVE_LOADER_MANT_INDK        =     'SAVE_LOADER_MANT_INDK';
export const GET_MANT_INDKS               =     'GET_MANT_INDKS';
export const GET_MANT_INDK                =     'GET_MANT_INDK';
export const FORM_MANT_INDK_FAIL          =     'FORM_MANT_INDK_FAIL';
export const MANT_INDK_FAILS              =     'MANT_INDK_FAILS';
export const MANT_INDK_FAIL               =     'MANT_INDK_FAIL';